export enum GridHeadersApiUrls {
  GetConfigurations = "/api/Configuration/GetConfigurations",
  UpdateConfigurations = "/api/Configuration/UpdateConfigurations",
  GetNetworkSampleFiles = "/api/Configuration/GetNetworkSampleFiles",
  GetJLUploadSampleFile = "/api/Configuration/GetJLUploadSampleFile",
  GetLocationSampleFile = "/api/Configuration/GetLocationSampleFile"
}
